export const isOfflineError = (error: any): boolean => {
  if (!error || !error.message) {
    return false;
  }
  const msg = error.message.toLocaleLowerCase();
  return (
    msg.includes('failed to fetch') ||
    msg.includes('service worker is an error')
  );
};
